/* THIS FILE IS AUTO-GENERATED – DO NOT EDIT */

import {forwardRef} from 'react'

/**
 * @public
 */
export const RetrieveIcon = forwardRef(function RetrieveIcon(
  props: React.SVGProps<SVGSVGElement>,
  ref: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      data-sanity-icon="retrieve"
      width="1em"
      height="1em"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...props}
    >
      <path
        d="M16 14L12.5 10.5L9 14M5.5 7.5H19.5"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinejoin="round"
      />
      <path
        d="M12.5 10.5L12.5 17.5M19.5 7.5V19.5H5.5V7.5L7.5 5.5H17.5L19.5 7.5Z"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinejoin="round"
      />
    </svg>
  )
})
RetrieveIcon.displayName = 'ForwardRef(RetrieveIcon)'
